module.exports = __webpack_public_path__ + "static/mock-app-phone-32470695a4e0bf121d9db0f64e202ff2.png";